import { connect } from 'react-redux';
import DataMapCardOverviewTab from './DataMapCardOverviewTab';
import { isReadOnly } from '../../../lib/ACLUtils';
import { fetchDataMapDoc, updateDataMapDoc } from '../../../actions';
import { GET_DATA_MAP_DOC_REQUEST } from '../../../constants/actionTypes';

const mapStateToProps = (state, ownProps) => {
  const {
    request,
    entities: { docs },
    dataMaps: { docById },
  } = state;
  const { data } = ownProps;
  const readOnly = isReadOnly(data);

  return {
    readOnly,
    doc: data && docById[data.id] && docs[docById[data.id]] ? docs[docById[data.id]].text : null,
    isLoadingDoc: !!request[GET_DATA_MAP_DOC_REQUEST],
  };
};

export default connect(mapStateToProps, { fetchDataMapDoc, updateDataMapDoc })(
  DataMapCardOverviewTab,
);
